// src/experiments/context.js
//
// Everything assignment may look at besides the uid, resolved synchronously
// from `window` so a decision can be made before React mounts. Nothing here
// reads the network or React state.

import { FLOW_SLUG_CONFIG } from '../utils/flowSlugConfig';
import { getBaseProductRoute } from '../utils/productNavigation';
import { isBotUserAgent } from '../utils/isBot';
import { MOBILE_MAX, TABLET_MAX } from '../utils/useIsMobile';

// Same thresholds as the useBreakpoint hook, read from innerWidth directly
// because the React context does not exist yet at assignment time.
export function getDevice(width) {
  if (width <= MOBILE_MAX) return 'mobile';
  if (width <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

// Product for a quote-flow URL (`/car-insurance-quote/step2` → CarInsurance),
// via the same slug lookup the GTM pageview uses. Results and thank-you pages
// carry the product in router state rather than the URL, so experiments on
// those surfaces target `paths` instead of `products`.
export function getProductForPath(pathname) {
  const slug = getBaseProductRoute(pathname || '/').replace(/^\//, '');
  return FLOW_SLUG_CONFIG[slug]?.product ?? null;
}

export function getContext(overrides = {}) {
  const hasWindow = typeof window !== 'undefined';
  const pathname =
    overrides.pathname ?? (hasWindow ? window.location.pathname : '/');
  return {
    pathname,
    product:
      overrides.product !== undefined
        ? overrides.product
        : getProductForPath(pathname),
    device:
      overrides.device ??
      (hasWindow ? getDevice(window.innerWidth) : 'desktop'),
    isBot: overrides.isBot ?? isBotUserAgent(),
  };
}
